<template>
    <div class="admin">
        <div v-if="consultations" class="admin__consultations">
            <consultation :consultation="consultation" :access="access" v-for="consultation in consultations" :key="consultation.id"></consultation>
            <div v-if="access === 'patient'" class="add-card">
                <a href="/doctors" class="add-card__button r-link button">Записаться к врачу</a>
            </div>
            <div v-else-if="loaded && consultations.length == 0 && access =='doctor'" class="admin__messages">
                <div class="u-message">
                    <div class="u-message__body" style="max-width: 100%">
                        <strong class="u-message__name r-strong">Записей на прием к вам еще не было</strong>
                        <div class="u-message__content">
                            <p>Пожалуйста, убедитесь, что вы заполнили свое расписание, чтобы пользователи могли записываться к вам на прием.</p>
                        </div>
                        <div class="u-message__action">
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="loaded && consultations.length == 0 && access =='clinic'" class="admin__messages">
                <div class="u-message">
                    <div class="u-message__body" style="max-width: 100%">
                        <strong class="u-message__name r-strong">У ваших врачей еще не было записей</strong>
                        <div class="u-message__content">
                            <p>Пожалуйста, убедитесь, что вы заполнили расписание своих врачей, чтобы позволить пользователям записываться к ним на прием.</p>
                        </div>
                        <div class="u-message__action">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../../admin/api/api";
    import store from './Room/store/room-store';
    import Consultation from './Consultation';

    export default {
        store,
        components: {Consultation},
        name: "Consultations",
        data() {
            return {
                consultations: [],
                access: window.laravel.userType,
                loaded: false
            }
        },
        mounted() {
            api.get('/api/consultations')
                .then((response) => {
                    this.consultations = response.data.consultations
                })
                .catch((error) => {
                    alert(error)
                })
                .finally(() => {
                    this.loaded = true;
                })
        }
    }
</script>
